import { Badge } from "react-bootstrap";

function StatusBadge({ status }) {
    let variant;
    switch (status) {
        case 'pending':
            variant = 'warning';
            break;
        case 'approved':
            variant = 'success';
            break;
        case 'rejected':
            variant = 'danger';
            break;
        case 'processed':
            variant = 'primary';
            break;
        default:
            variant = 'secondary';
    }

    return <Badge variant={variant}>{status.toUpperCase()}</Badge>;
}

export default StatusBadge;
